import {
    NATIVE_INVOICE_TERM_TYPES,
    NATIVE_INVOICE_TERM_TYPE_LABELS,
    NativeInvoiceTermType,
} from "@common/helpers/invoice-terms.helper";

export const NATIVE_INVOICE_TERM_OPTIONS: Array<{
    value: NativeInvoiceTermType;
    label: string;
}> = NATIVE_INVOICE_TERM_TYPES.map((value) => ({
    value,
    label: NATIVE_INVOICE_TERM_TYPE_LABELS[value],
}));
